"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatHeart = void 0;

var tslib_1 = require("tslib");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var ChatHeart = function ChatHeart() {
  var filterId = (0, use_id_1.useId)();
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("filter", {
    id: filterId,
    filterUnits: "objectBoundingBox"
  }, react_1.default.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "1 0 0 0 0.4\n     0 1 0 0 0.4\n     0 0 1 0 0.4\n     0 0 0 1 0"
  })), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M1.50231 11.9989C1.50231 13.5622 1.8524 15.0555 2.47073 16.3855C2.71573 16.8988 2.7158 17.4938 2.5408 18.0422L1.5607 20.9588C1.25737 21.8688 2.13239 22.7438 3.04239 22.4405L5.95905 21.4605C6.50739 21.2855 7.1023 21.2855 7.61563 21.5305C8.94563 22.1488 10.439 22.4988 12.0023 22.4988C17.8006 22.4988 22.5012 17.7983 22.5012 12C22.5012 6.20166 17.8006 1.50113 12.0023 1.50113C6.20281 1.49996 1.50231 6.20052 1.50231 11.9989Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M16.5792 11.7597C15.9702 14.8735 11.9999 16.6667 11.9999 16.6667C11.9999 16.6667 8.02972 14.8735 7.42072 11.7597C7.04738 9.8487 7.86289 7.92719 9.93606 7.91669C11.4807 7.90969 11.9988 9.45435 11.9988 9.45435C11.9988 9.45435 12.5169 7.90852 14.0615 7.91669C16.1405 7.92719 16.9525 9.8487 16.5792 11.7597Z",
    fill: "currentColor"
  }));
};

exports.ChatHeart = ChatHeart;